module.exports = __webpack_public_path__ + "static/person-4.d89a7e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicare/person-4.png
// module id = 3720
// module chunks = 129662963943619